import { Button, Flex, mediaQueries, Theme, Typography } from "@ugc-ui/lego";
import styled from "@emotion/styled";

export const ProfileMenuSharedContentStyled = styled(Flex)`
  padding: 18px 8px;

  ${mediaQueries.lg} {
    padding: 0;
  }
`;

export const MenuContent = styled(Flex)<{ theme: Theme }>`
  flex-direction: column;
  width: 100%;
`;

export const TypographyStyled = styled(Typography)<{ theme: Theme }>`
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: ${({ theme }) => theme.gray.a60};
  padding: 0 16px;
  margin-bottom: 24px;

  ${mediaQueries.lg} {
    padding: 0;
  }
`;

export const TypographyStyledCaption = styled(Typography)<{ theme: Theme }>`
  color: ${({ theme }) => theme.gray.a40};
  padding: 0 16px;
  margin-bottom: 6px;

  ${mediaQueries.lg} {
    padding: 0;
  }
`;

export const ButtonStyled = styled(Button)`
  justify-content: flex-start;
  padding: 0 12px;

  :hover {
    background-color: transparent;
  }

  ${mediaQueries.lg} {
    padding: 0;
  }
`;

export const Line = styled.div<{ theme: Theme }>`
  border-top: 1px solid ${({ theme }) => theme.gray.a10};
  margin: 12px 0 12px 0;
`;
